import { render, staticRenderFns } from "./ModalLabelGroups.vue?vue&type=template&id=65f65ab0&lang=pug&"
import script from "./ModalLabelGroups.vue?vue&type=script&lang=js&"
export * from "./ModalLabelGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports